var $112e467ad7137275$exports = {};
$112e467ad7137275$exports = {
  "help": `Hilfe`,
  "info": `Informationen`
};
export { $112e467ad7137275$exports as default };